import { routeOptions } from '@/components/navigation/left/constants';

/**
 * Resolve the AtlasRouteId for a pathname — the single definition of the analytics
 * `Current Route` property.
 * e.g. "/org/facility/alarms" -> "alarms"
 * Returns undefined when the path is not a facility page or matches no known route.
 */
export function resolveRouteId(pathname: string): string | undefined {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length < 3) {
    // Not on a facility page
    return undefined;
  }

  // The page name is the last segment
  const currentPath = segments[segments.length - 1];

  return routeOptions.find((route) => route.id === currentPath)?.id;
}
